/* Insurance direct-billing inquiry form. With the Apps Script relay configured
   (theme setting shared with careers), submissions post the fields + insurance
   card photos to it, which emails the recipient with the photos attached and
   archives them in Drive. Without it — or if the relay fails — the native
   Shopify contact form submits so no inquiry is ever lost. */
(function () {
  function init() {
    var wrap = document.querySelector('[data-insurance-wrap]');
    if (!wrap) return;
    var form = wrap.querySelector('form');
    if (!form) return;

    var endpoint = wrap.getAttribute('data-upload-url');
    var servicesField = wrap.querySelector('[data-ins-services-field]');
    var servicesError = wrap.querySelector('[data-ins-services-error]');
    var fileField = wrap.querySelector('[data-ins-file-field]');
    var fileInput = wrap.querySelector('[data-ins-files]');
    var fileNote = wrap.querySelector('[data-ins-file-note]');
    var errorEl = wrap.querySelector('[data-ins-error]');
    var successEl = wrap.querySelector('[data-ins-success]');
    var submitBtn = wrap.querySelector('[data-ins-submit]');

    // photo upload needs the relay — only show the field when it's configured
    if (endpoint && fileField) fileField.hidden = false;

    function checkedServices() {
      return Array.prototype.map.call(
        wrap.querySelectorAll('[data-ins-service]:checked'),
        function (c) { return c.value; }
      );
    }

    wrap.addEventListener('change', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-ins-service')) {
        servicesField.value = checkedServices().join(', ');
        if (servicesError && checkedServices().length) servicesError.hidden = true;
      }
      if (e.target === fileInput && fileNote) {
        var names = Array.prototype.map.call(fileInput.files, function (f) { return f.name; });
        var tooBig = Array.prototype.some.call(fileInput.files, function (f) { return f.size > 10 * 1024 * 1024; });
        if (tooBig) {
          fileInput.value = '';
          fileNote.textContent = 'Each photo must be under 10 MB — please choose smaller files.';
          fileNote.hidden = false;
        } else {
          fileNote.textContent = names.join(', ');
          fileNote.hidden = names.length === 0;
        }
      }
    });

    form.addEventListener('submit', function (e) {
      if (!checkedServices().length) {
        e.preventDefault();
        if (servicesError) servicesError.hidden = false;
        servicesError.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      servicesField.value = checkedServices().join(', ');

      if (!endpoint) return; // native contact form path

      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending inquiry…';

      var val = function (sel) { return (wrap.querySelector(sel) || {}).value || ''; };
      var services = checkedServices();
      var detail = [
        'Insurance company: ' + val('[data-ins-company]'),
        'Policy/plan number: ' + val('[data-ins-policy]'),
        'Service(s) of interest: ' + services.join(', ')
      ].join('\n');

      var files = fileInput ? Array.prototype.slice.call(fileInput.files) : [];
      Promise.all(files.map(function (f) {
        return new Promise(function (resolve, reject) {
          var r = new FileReader();
          r.onload = function () {
            resolve({ filename: f.name, mimeType: f.type || 'application/octet-stream', data: String(r.result).split(',')[1] });
          };
          r.onerror = reject;
          r.readAsDataURL(f);
        });
      })).then(function (encoded) {
        var payload = {
          kind: 'insurance',
          recipient: wrap.getAttribute('data-recipient') || '',
          hiringEmail: wrap.getAttribute('data-recipient') || '',
          name: val('[data-ins-name]'),
          email: val('[data-ins-email]'),
          phone: val('[data-ins-phone]'),
          insuranceCompany: val('[data-ins-company]'),
          policy: val('[data-ins-policy]'),
          services: services,
          note: detail,
          files: encoded,
          page: window.location.href
        };
        // older relay versions read a single file — include the first one flat
        if (encoded[0]) {
          payload.filename = encoded[0].filename;
          payload.mimeType = encoded[0].mimeType;
          payload.data = encoded[0].data;
        }
        // text/plain keeps this a "simple" request (no CORS preflight, which
        // Apps Script web apps cannot answer)
        return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) })
          .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); });
      }).then(function (d) {
        if (d && (d.ok || d.result === 'ok')) {
          form.hidden = true;
          if (successEl) { successEl.hidden = false; wrap.appendChild(successEl); }
        } else {
          throw new Error((d && d.error) || 'Relay failed');
        }
      }).catch(function () {
        // relay unavailable — fall back to the native contact form so the
        // inquiry still arrives (without photo attachments)
        submitBtn.disabled = false;
        form.submit();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
